import {
    BannersEditMassActions,
    CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
    ON_OPEN_MASS_ACTIONS_COUNTERS
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import {
    ADD_SHOWS_COUNTERS_ROW,
    CHANGE_SHOWS_COUNTERS_VALUE,
    CpmBannerActions,
    REMOVE_SHOWS_COUNTERS_ROW
} from '../../../actions/banners-edit/cpm-banner';
import { ADDITIONAL_SHOW_COUNTERS_LENGTH } from '../../../constants';
import { BannersEditMassActionsState, MassActionId } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsCountersReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions | CpmBannerActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case REMOVE_SHOWS_COUNTERS_ROW:
            if (action.bannerId !== MassActionId.bannersEdit) {
                return { ...state };
            }

            return {
                ...state,
                [action.bannerId]: {
                    ...state[action.bannerId],
                    data: {
                        ...state[action.bannerId].data,
                        counters: state[action.bannerId].data.counters.filter((val, i) => i !== action.index)
                    }
                }
            };
        case ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR:
            return {
                ...bannersEditMassActionsInitialState,
                [action.massActionId]: {
                    ...bannersEditMassActionsInitialState[action.massActionId],
                    data: {
                        ...state[action.massActionId].data
                    }
                }
            };
        case ON_OPEN_MASS_ACTIONS_COUNTERS:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        countersEditorVisible: true
                    }
                }
            };
        case CHANGE_SHOWS_COUNTERS_VALUE:
            if (action.bannerId !== MassActionId.bannersEdit) {
                return state;
            }

            const { data } = state[action.bannerId];

            const newShowsCounters = [...data.counters];
            newShowsCounters[action.index] = action.value;

            return {
                ...state,
                [action.bannerId]: {
                    ...state[action.bannerId],
                    data: {
                        ...state[action.bannerId].data,
                        counters: newShowsCounters.map(count => count.trim())
                    }
                }
            };
        case ADD_SHOWS_COUNTERS_ROW:
            if (action.bannerId !== MassActionId.bannersEdit) {
                return state;
            }

            if (state[action.bannerId].data.counters.length > ADDITIONAL_SHOW_COUNTERS_LENGTH) {
                return state;
            }

            const newCounters = [...state[action.bannerId].data.counters];
            newCounters.push('');

            return {
                ...state,
                [action.bannerId]: {
                    ...state[action.bannerId],
                    data: {
                        ...state[action.bannerId].data,
                        counters: newCounters
                    }
                }
            };
        case CLOSE_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        default:
            return state;
    }
}
